export namespace Config {
    export const vueMultiselectParams = {
        noOptions: "Aucune sélection",
        selectLabel: "Sélectionner",
        deselectLabel: "Désélectionner",
    };
}
